module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ロゴ表示用LEDモジュール.30775006.png";